import { ChangeDetectorRef, Component, Inject, Injector, OnInit } from '@angular/core';
import { TuiDialog } from '@taiga-ui/cdk';
import { POLYMORPHEUS_CONTEXT, PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';
import { Observable } from 'rxjs';
import { LOCATION } from '@ng-web-apis/common';
import { MetricsService, TRACKABLE_EVENTS } from '@fb-tool-front/core/services/metrics.service';
import { StripeStore } from '@fb-tool-front/stripe/store/stripe.store';
import { Stripe } from '@fb-tool-front/stripe/models/stripe.model';
import { CustomDialogService } from '@fb-tool-front/shared/components/dialog/dialog.component';
import { DemoRequestComponent } from '@fb-tool-front/auth/demo-request/demo-request.component';
import { ClientSubscriptionTypes } from '@fb-tool-front/shared/constants/auth.constants';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { StripeService } from '@fb-tool-front/stripe/services/stripe.service';
import { AuthService } from '@fb-tool-front/core/services/auth.service';
import { finalize } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';

@UntilDestroy()
@Component({
  selector: 'app-pricing-modal',
  templateUrl: './pricing-modal.component.html',
  styleUrls: ['./pricing-modal.component.scss']
})
export class PricingModalComponent implements OnInit {
  plans$: Observable<Stripe.Product[]> = this.stripeStore.products$;
  currentPlan$: Observable<Stripe.Product | string> = this.stripeStore.currentProduct$;
  productCount: number;
  plansLoader = false;
  agreement = new UntypedFormControl(false);

  constructor(
    private metricsService: MetricsService,
    private stripeService: StripeService,
    private stripeStore: StripeStore,
    private authService: AuthService,
    private customDialogService: CustomDialogService,
    @Inject(POLYMORPHEUS_CONTEXT) readonly context: TuiDialog<any, any>,
    @Inject(LOCATION) readonly location: Location,
    @Inject(Injector) private readonly injector: Injector
  ) {}

  changePlan(plan: Stripe.Product) {
    this.metricsService.trackEvent(TRACKABLE_EVENTS.switchPlan());

    this.plansLoader = true;

    this.stripeService
      .checkoutSession({
        client: this.authService.getCurrentClient().id,
        price: plan.prices[0].id,
        success_url: `${
          location.href + (location.href.includes('?') ? '&fromStripe=true' : '?fromStripe=true')
        }`,
        cancel_url: `${this.location.href}`
      })
      .pipe(finalize(() => (this.plansLoader = false)))
      .subscribe(res => this.location.replace(res.url));
  }

  close() {
    this.context.completeWith();
  }

  showContactModal() {
    this.customDialogService
      .open<boolean>(new PolymorpheusComponent(DemoRequestComponent, this.injector), {
        closeable: true,
        withoutHeading: true,
        customButtons: true,
        data: {
          clientSubscription: ClientSubscriptionTypes.facebookCommerce
        }
      })
      .pipe(untilDestroyed(this))
      .subscribe((res: boolean) => {
        if (res) {
          this.context.completeWith();
        }
      });
  }

  ngOnInit(): void {
    this.productCount =
      this.context?.data?.productCount || this.context?.data?.plan?.product_limit + 1;
  }

  isPriceHasCents(price: number) {
    return parseInt(price.toString().split('.')?.[1]) > 0;
  }
}
